export default __webpack_public_path__ + "static/media/Subscription-sucess.edead2ff.png";